import React, { useEffect } from "react";
import Routes from "./Routes";
import CookieConsent from "./components/CookieConsent";
import GeoBanner from "components/india/GeoBanner";
import { initV5Shell } from "./utils/v5Shell";

function App() {
  useEffect(() => {
    initV5Shell();
  }, []);

  return (
    <>
      {/* V5 global overlays */}
      <div id="loader" aria-hidden="true">
        <div id="lWord" className="l-word"></div>
        <div id="lBar" className="l-bar">
          <div id="lBarFill" className="l-bar-fill"></div>
        </div>
        <div className="l-sub">The proof-of-concept company</div>
      </div>
      <div className="grain"></div>
      <div id="cur"></div>

      <GeoBanner />
      <Routes />
      <CookieConsent />
    </>
  );
}

export default App;
